import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth";
import TextField from "@material-ui/core/TextField";
import Drawer from "@material-ui/core/Drawer";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListSubheader from "@material-ui/core/ListSubheader";
import IconButton from "@material-ui/core/IconButton";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import SettingsIcon from "@material-ui/icons/Settings";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import LinearProgress from "@material-ui/core/LinearProgress";

import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from "@material-ui/core/MenuItem";

import { listenCourseActivity, searchCourses } from "../firebaseApi";
import { changeCourses } from "../redux";

import StudentMenuCourseItem from "./StudentMenuCourseItem";
import StudentSettings from "./StudentSettings";
import StudentCourseSettings from "./StudentCourseSettings";
import SelectRole from "./SelectRole";

import {
  Typography,
  Dialog,
  DialogContent,
  Button,
  DialogActions,
} from "@material-ui/core";

const styles = (theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  headerListItem: {
    padding: 0,
  },
  drawer: {
    width: 260,
    zIndex: 1,
  },
  searchOptions: {
    margin: "6px 12px 12px 12px",
    minHeight: 0,
    "& .MuiTab-root": {
      minWidth: 0,
      padding: 3,
      minHeight: 0,
    },
  },
  searchOptionsTitle: {
    color: "gray",
    margin: "6px 12px 12px 12px",
    borderBottom: "1px solid gray",
  },
  search: {
    margin: "0px 12px 12px 12px",
  },
});

function StudentMenu(props) {
  const [search, setSearch] = React.useState({ tab: 0, query: "" });
  const [searchResults, setSearchResults] = React.useState({});
  const [settingsOpen, setSettingsOpen] = React.useState(false);
  const [courseSettings, setCourseSettings] = React.useState({
    open: false,
    course: null,
  });
  const [enrollLoading, setEnrollLoading] = React.useState(false);
  const [restrictDomainDialog, setRestrictDomainDialog] = React.useState(false);
  const [restrictDomainCourse, setRestrictDomainCourse] = React.useState(null);
  const [overrideCode, setOverrideCode] = React.useState("");
  const [showCourse, setShowCourse] = React.useState({});

  let mobile = props.width === "sm" || props.width === "xs";

  function selectCourse(course) {
    let route = "/student/" + course.courseID;

    if ((course.courseActivityPollLive || course.courseActivityPollDisplay) && course.courseActivityPollID) {
      route = route + "/" + course.courseActivityPollID;
    }
    
    props.history.push(route);
    if (mobile) {
      props.openCtl(false);
    }
  }
  function returnHome(){
    let route = "/student/"
    props.history.push(route);
    if (mobile) {
      props.openCtl(false);
    }
  }
  function selectCourseTA(course) {
    let route = "/student/" + course.courseID + "/I_is_TA";
    
    props.history.push(route);
    if (mobile) {
      props.openCtl(false);
    }
  }
  function handleAddCourse(course) {
    setEnrollLoading(true);
    setSearch({ tab: 0, query: "" });
    setSearchResults({});
    props.enrollStudent(course.courseID).then(() => {
      setEnrollLoading(false);
      let route = "/student/" + course.courseID;

      if ((course.courseActivityPollLive || course.courseActivityPollDisplay) && course.courseActivityPollID) {
        // route = course.courseActivityPollID
        //   ? route + "/" + course.courseActivityPollID
        //   : route;
          route = route + "/" + course.courseActivityPollID;
      }
      props.history.push(route);
      if (mobile) {
        props.openCtl(false);
      }
    });
  }

  function removeCourseFromMenu(course) {
    let remainingCourses = {...props.courses};
    delete remainingCourses[course.courseID];
    props.changeCourses(remainingCourses);

    if (props.urlParams.courseID && props.urlParams.courseID == course.courseID) {
      props.history.push("/student/");
    }
  }

  // Open student settings if student has not filled out student identifier
  // React.useEffect(() => {
  //   if (
  //     props.courses?.[props.match.params?.courseID]?.forcePID &&
  //     !props.account.accountIdentifier
  //   ) {
  //     if (props.account.accountEmail == "") {
  //       return;
  //     }
  //     setSettingsOpen(true);
  //   }
  // }, [props.match.params.courseID]);
  let funcer = ()=>{
    console.log(props.lotProps)
    console.log(props.taCourses)
  }
  React.useEffect(()=>{
    const courseList = Object.values(props.courses).map(course => course.courseID);
    const obj = {};
    for (const courseID of courseList) {
      if(showCourse[courseID] == true || showCourse[courseID] == false){
        obj[courseID] = showCourse[courseID]; 
      }else{
        obj[courseID] = 1 // Initialize each key with a default value
      }
    }
    setShowCourse(obj);
  },[props.courses])

  return (
    <div>
      <Drawer
        disableEnforceFocus
        classes={{ paper: props.classes.drawer }}
        anchor="left"
        variant={mobile ? "temporary" : "persistent"}
        open={props.open}
        onClose={() => {
          props.openCtl(false);
        }}
      >
        {mobile ? null : <div className={props.classes.appBarSpacer} />}
        <div
          className={props.classes.headerListItem}
          style={{
            display: "flex",
            flexDirection: "column",
            paddingLeft: 15,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <ListItemText
              style={{ paddingTop: 8 }}
              primary={
                props.account.accountFirstName +
                " " +
                props.account.accountLastName
              }
            />
            {props.account.accountType === "student" && props.account.accountEmail && (
              <IconButton onClick={() => {setSettingsOpen(true)}}>
                <SettingsIcon />
              </IconButton>
            )}
            <div style={{ marginTop: 9, display: props.account.accountType === "student" ? "none" : "block" }}>
              <SelectRole />
            </div>
            <IconButton onClick={props.logout}>
              <ExitToAppIcon />
            </IconButton>
          </div>
          <ListItemText secondary={props.account.accountEmail} />
        </div>

        <Divider />

        {!props.account.accountEmail ? null : (
          <div>
            <List
              subheader={
                <ListSubheader
                  style={{
                    fontSize: "1.1rem",
                    fontWeight: "bold",
                    color: "black",
                  }}
                >
                  Courses
                </ListSubheader>
              }
            >
              {Object.values(props.courses).map((course) =>
                (course.isActive  && showCourse[course.courseID])? (
                  <StudentMenuCourseItem
                    key={course.courseID}
                    disable={false}
                    studentID={props.account.accountEmail}
                    course={course}
                    handleCategoriesDialog={props.handleCategoriesDialog}
                    selected={course.courseID === props.urlParams.courseID}
                    removeCourseFromMenu={() => removeCourseFromMenu(course)}
                    selectCourse={() => selectCourse(course)}
                    unselect = {()=> returnHome()}
                    editCourse={() => {
                      setCourseSettings({ open: true, course });
                    }}
                    refreshCourseListen={(courseID) =>
                      props.refreshCourseListen(courseID)
                    }
                    showPoll = {(courseID)=>{
                      let obj = showCourse;
                      obj[courseID] = 0;
                      setShowCourse(obj);
                    }}
                  />
                ) : null
              )}
              {Object.values(props.anonCourses).map((course) => 
                course.isActive ? 
                (
                  <StudentMenuCourseItem
                    key={course.courseID}
                    disable={true}
                    studentID={props.account.accountEmail}
                    course={course}
                    handleCategoriesDialog={props.handleCategoriesDialog}
                    selected={false}
                    selectCourse={() => {}}
                    unselect = {()=> {}}
                    editCourse={() => {}}
                    refreshCourseListen={() => {}}
                    showPoll = {() => {}}
                  />
                ) : null
              )}
            </List>
            {false ? <List
              subheader={
                <ListSubheader
                  style={{
                    fontSize: "1.1rem",
                    fontWeight: "bold",
                    color: "black",
                  }}
                >
                  TA Courses
                </ListSubheader>
              }
            >
              <button onClick={funcer}>
                Potato
              </button>
              {Object.values(props.courses).map((course) =>
                (course.isActive  && showCourse[course.courseID])? (
                  <StudentMenuCourseItem
                    key={course.courseID}
                    studentID={props.account.accountEmail}
                    course={course}
                    removeCourseFromMenu={() => removeCourseFromMenu(course)}
                    handleCategoriesDialog={props.handleCategoriesDialog}
                    selected={course.courseID === props.urlParams.courseID}
                    unselect = {()=> returnHome()}
                    selectCourse={() => selectCourseTA(course)}
                    editCourse={() => {
                      setCourseSettings({ open: true, course });
                    }}
                    refreshCourseListen={(courseID) =>
                      props.refreshCourseListen(courseID)
                    }
                    showPoll = {(courseID)=>{
                      let obj = showCourse;
                      obj[courseID] = 0;
                      setShowCourse(obj);
                    }}
                  />
                ) : null
              )}
            </List>
            : null}
            <Divider />
          </div>
        )}
        {(!props.account.accountEmail && props.match.params.courseID) ? null : 
          <>
          <ListSubheader
            style={{
              fontSize: "1.1rem",
              fontWeight: "bold",
              color: "black",
            }}
          >
            Enroll in Course
          </ListSubheader>
          {/* <Tabs
            className={props.classes.searchOptions}
            value={search.tab}
            onChange={(_, value) => setSearch({ tab: value, query: "" })}
          >
            <Tab label="Encoll with Code" />
            <Tab label="Name" /> 
          </Tabs> */}
          
          <TextField
            className={props.classes.search}
            variant="outlined"
            size="small"
            label={search.tab ? "Course Name" : "Course Code"}
            value={search.query}
            onChange={(event) => {
              setSearch({
                ...search,
                query: search.tab
                  ? event.target.value
                  : event.target.value.toUpperCase(),
              });
              let searchField = search.tab ? "courseName" : "courseCode";
              let data = {
                [searchField]: event.target.value,
                anonSearch: props.account.accountEmail === "",
              };

              searchCourses(data).then((courses) => {
                setSearchResults(courses);
              });
            }}
          />

          <List>
            {enrollLoading ? <LinearProgress /> : null}
            {Object.values(searchResults).map((course) => (
              <ListItem
                key={course.courseName}
                button
                disabled={enrollLoading}
                onClick={() => {
                  //console.log(course);
                  if (
                    course?.restrictDomain &&
                    !props.account.accountEmail.endsWith(
                      course.restrictDomainEmail
                    )
                  ) {
                    setRestrictDomainCourse(course);
                    setRestrictDomainDialog(true);
                    return;
                  }

                  handleAddCourse(course);
                }}
              >
                <ListItemText
                  primary={course.courseName}
                  secondary={
                    course.courseTerm !== undefined ? course.courseTerm : ""
                  }
                />
              </ListItem>
            ))}
          </List>
          </>
        }
      </Drawer>

      <Dialog
        fullScreen={mobile}
        fullWidth
        maxWidth="sm"
        open={restrictDomainDialog}
      >
        <DialogContent>
          <Typography variant="h6" style={{ marginBottom: "16px" }}>
            You are not allowed to access this class. This class is restricted
            to {restrictDomainCourse?.restrictDomainEmail} domain. If the
            instructor provides a special permission code to bypass this
            restriction, enter below and click confirm.
          </Typography>
          <TextField
            label="Override code"
            variant="outlined"
            fullWidth
            value={overrideCode}
            onChange={(e) => setOverrideCode(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            onClick={() => {
              setRestrictDomainDialog(false);
            }}
          >
            Close
          </Button>
          <Button
            color="primary"
            onClick={() => {
              if (
                restrictDomainCourse?.restrictDomainOverride === overrideCode
              ) {
                handleAddCourse(restrictDomainCourse);
                setRestrictDomainDialog(false);
              }
            }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <StudentSettings
        // key={"Student Settings" + }
        account={props.account}
        editStudentInfo={props.editStudentInfo}
        open={settingsOpen}
        openCtl={(open) => setSettingsOpen(open)}
        forcePID={props.courses?.[props.match.params?.courseID]?.forcePID}
      />
      <StudentCourseSettings
        // key={"Course Settings" + this.state.courseSettingsOpen}
        courseName={courseSettings.open ? courseSettings.course.courseName : ""}
        iClicker={
          courseSettings.open
            ? courseSettings.course.students[props.account.accountID].iClicker
            : ""
        }
        editStudentCourseInfo={(iClicker) =>
          props.editStudentCourseInfo(
            courseSettings.open ? courseSettings.course.courseID : "",
            iClicker
          )
        }
        open={courseSettings.open}
        openCtl={(open) => {
          setCourseSettings({ open, course: {} });
        }}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeCourses: (data) => dispatch(changeCourses(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(withStyles(styles, { withTheme: true })(withWidth()(StudentMenu)))
);
